var exports = {
  "kL": "AttachmentFile.module__container___T2JSa0",
  "G5": "AttachmentFile.module__deleteButton___T2JSa0",
  "Dq": "AttachmentFile.module__attachmentContainer___T2JSa0",
  "zc": "AttachmentFile.module__iconContainer___T2JSa0",
  "el": "AttachmentFile.module__fileInfoContainer___T2JSa0",
  "Md": "AttachmentFile.module__fileName___T2JSa0",
  "m$": "AttachmentFile.module__fileNameTruncate___T2JSa0",
  "i_": "AttachmentFile.module__fileExtension___T2JSa0",
  "Ov": "AttachmentFile.module__fileSize___T2JSa0",
  "l6": "AttachmentFile.module__downloadButton___T2JSa0",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___T2JSa0",
};

module.exports = exports;
